import {NgModule} from '@angular/core';
import {ProfileComponent} from "./profile.component";
import {FormsModule} from "@angular/forms";
import {ProfileService} from "../../services/profile/profile.service";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {BrowserModule} from "@angular/platform-browser";
import {ModalModule} from "ngx-bootstrap/modal";
import {WarningModalModule} from "../../lib/warning-modal/warning-modal.module";
import {AlertBannerModule} from "../../lib/alert-banner";
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {EmailEditModalModule} from "../../components/email-edit-modal/email-edit-modal.module";
import {SystemLangEditModalModule} from "../../components/system-lang-edit-modal/system-lang-edit-modal.module";
import {PasswordUpdateModalModule} from "../../components/password-update-modal/password-update-modal.module";
import {MobileNumberModalModule} from "../../components/mobile-number-modal/mobile-number-modal.module";
import {ImageUploadModule} from "../../lib/image-upload/image-upload.module";
import {PhoneInputModule} from "../../lib/phone-input/phone-input.module";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {TooltipEllipsifyModule} from "../../directives/tooltip-ellipsify/tooltip-ellipsify.module";
import {CommonModule} from "@angular/common";
import { FooterModule } from 'src/app/components/footer/footer.module';
import { LoaderModule } from 'src/app/components/loader/loader.module';
import {IdService} from "../../services/id/id.service";
import { ButtonModule } from '@xref/xref-lib';
import { MobileVerificationModalModule } from '../../components/mobile-verification-modal/mobile-verification-modal.module';
import {MfaModalModule} from "../../components/mfa-modal/mfa-modal.module";
import {AuthenticatorModalModule} from "../../components/authenticator-modal/authenticator-modal.module";

@NgModule({ declarations: [
        ProfileComponent,
    ], imports: [BrowserModule,
        FormsModule,
        CommonModule,
        ModalModule,
        WarningModalModule,
        AlertBannerModule.forRoot(),
        AlertMessageModule,
        EmailEditModalModule,
        SystemLangEditModalModule,
        PasswordUpdateModalModule,
        MobileNumberModalModule,
        ImageUploadModule,
        PhoneInputModule,
        TooltipModule.forRoot(),
        TooltipEllipsifyModule,
        FooterModule,
        ButtonModule,
        MfaModalModule,
        AuthenticatorModalModule,
        MobileVerificationModalModule,
        LoaderModule],
        providers: [
        ProfileService,
        IdService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class ProfileModule {
}
